export default __webpack_public_path__ + "static/media/menuDigitale.3d51ac74.jpg";